import React, { useContext, useEffect, useMemo, useState } from "react";
import {
  Avatar,
  IconButton,
  Menu,
  MenuItem,
  Divider,
  ListItemIcon,
  Box,
  Skeleton,
} from "@mui/material";
import BellIcon from "../../icons/bellIcon";
import SupportIcon from "../../icons/supportIcon";
import { UserContext } from "../../context/UserContext";
import Button from "../../components/Button";
import {
  Logout,
  SearchOutlined,
  LocationOn,
  KeyboardArrowDown,
} from "@mui/icons-material";
import { useAllCities } from "../../hooks/services/useAllCities";
import { useBrand } from "../../hooks/services/useBrand";
import { useLogout } from "../../hooks/services/uselogout";
import { deepOrange } from "@mui/material/colors";
import { useLocation, useNavigate } from "react-router-dom";
import { useLogin } from "../../hooks/services/useLogin";
// import logo from '../../assets/images/icons8-notification-48.png'
import Updatelogo from "../../assets/images/loop_6816180.png";
import { Notificationconsumer } from "../../hooks/services/notifications";
import { useMail } from "../../hooks/services/useMail";
import { useSubCategory } from "../../hooks/services/useSubCategory";
import { useCategory } from "../../hooks/services/useCategory";
import { usePopupsdatadetails } from "../../hooks/services/usePopupaddsdetails";
import {
  REACT_APP_COOKIE_DOMAIN,
  REACT_APP_COOKIE_SECURE,
} from "../../connections";
import { useCookies } from "react-cookie";
import Badge from "@mui/material/Badge";
import NotificationsIcon from "@mui/icons-material/Notifications";
import LoopIcon from "@mui/icons-material/Loop";

export const useGetNavItems = ({
  handleNavLinksClick = () => void 0,
  selCountry,
  selCategory,
  selState,
  selCity,
  setcityactive,
  setSelCity,
  setSelCountry,
  setSelState,
  setSelCounty,
  selCounty,
  selBrand,
  setSelBrand,
  subCatActive,
  onDrawerNotification,
  handleClickOpen1,
  Popupaddsdata,
  // "dark" (default) matches the green brand header used everywhere else;
  // "light" matches the native app's home-screen header (light background,
  // so icons/text need to read dark instead of white).
  theme = "dark",
}) => {
  const isLight = theme === "light";
  const location = useLocation();
  const navigate = useNavigate();
  const { setData } = useLogin();
  const [cityName, setCityName] = useState("");
  // const [cityactive,setcityactive] = useState('')
  const MENU_NAME = "Notifications";

  let userdata = JSON.parse(localStorage.getItem("user"));
  const styles = {
    unreadCount: {
      position: "absolute",
      top: "-5px",
      right: "-5px",
      background: "red",
      color: "white",
      borderRadius: "50%",
      padding: "3px 6px",
      fontSize: "10px",
      height: "20px",
      width: "20px",
      textAlign: "center",
    },
    citySelect: {
      justifyContent: "flex-start",
      border: "none",
      borderRadius: "8px",
      minWidth: "100px",
      padding: "6px 12px",
      fontSize: "0.85rem",
      fontWeight: 500,
      color: "#555",
      backgroundColor: "rgba(84, 172, 52, 0.05)",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      "&:hover": {
        backgroundColor: "rgba(84, 172, 52, 0.1)",
      },
    },
    cityDropdown: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      padding: "4px 12px",
      borderRadius: "8px",
      backgroundColor: "rgba(84, 172, 52, 0.05)",
      cursor: "pointer",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      "&:hover": {
        backgroundColor: "rgba(84, 172, 52, 0.1)",
        transform: "translateY(-1px)",
      },
    },
  };

  const { setPayloadsLogout } = useLogout();
  const { cityList: cityData, isLoading: isCityLoading } = useAllCities();
  // Some city names exist more than once in the data (e.g. two separate
  // "Frisco" records under different counties, only one of which actually
  // has stores) — disambiguate those with their county/state so users can
  // tell them apart, instead of two identical-looking, unexplained options.
  const cityNameCounts = useMemo(() => {
    const counts = {};
    cityData?.forEach((city) => {
      counts[city?.name] = (counts[city?.name] ?? 0) + 1;
    });
    return counts;
  }, [cityData]);
  const getCityMenuLabel = (city) => {
    if ((cityNameCounts[city?.name] ?? 0) <= 1) return city?.name;
    const county = city?.counties?.[0]?.name;
    const state = city?.states?.[0]?.name;
    const suffix = [county, state].filter(Boolean).join(", ");
    return suffix ? `${city?.name} (${suffix})` : city?.name;
  };
  const {
    noticationdata,
    unread,
    setPayloadsdata,
    setpage,
    setlimit,
    setsearch,
    count,
    setStateChange,
    stateChange,
    page,
  } = Notificationconsumer();
  const {
    mailList,
    mailCount,
    isRedeem,
    redeemMessage,
    redeemError,
    mailHTML,
    setUpdateMailFav,
    setUpdateMailRedeem,
    setMailURL,
    isMailLoading,
  } = useMail();

  const {
    barndList,
    brandCount,
    brandpayload1,
    setBrandPayload1,
    setUpdateBrandFav,
    isBrandLoading,
  } = useBrand();
  const { categoryList, setCatPayload1, payload1 } = useCategory();
  const { subCategoryList = [], setSubParam, setCatParam } = useSubCategory();

  const { setPayloadspopup, Popupaddsdatadetails1, setDatapopup } =
    usePopupsdatadetails();
  useEffect(() => {
    const match = cityData?.find((itemData) => itemData?.uuid === selCity);
    if (match) {
      setCityName(match?.name);
    }
  }, [cityData, selCity]);

  const { userDetails, setUserDetails, setActiveBrand } =
    useContext(UserContext);

  const homeCityUuid = userDetails?.address?.city || userDetails?.city;
  // Home city pinned first (with a divider below it), everything else
  // alphabetical by its (possibly disambiguated) label.
  const sortedCityData = useMemo(() => {
    if (!cityData?.length) return [];
    const home = cityData.filter((city) => city?.uuid === homeCityUuid);
    const rest = cityData
      .filter((city) => city?.uuid !== homeCityUuid)
      .sort((a, b) =>
        getCityMenuLabel(a).localeCompare(getCityMenuLabel(b), undefined, {
          sensitivity: "base",
        }),
      );
    return [...home, ...rest];
  }, [cityData, homeCityUuid, cityNameCounts]);

  useEffect(() => {
    const data = {
      id: userdata?.uuid,
    };
    setPayloadsdata(userdata?.uuid);

    // setPayloads(data)

    setStateChange(!stateChange);
    setPayloadspopup(userdata?.uuid);
  }, []);

  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [cityAnchorEl, setCityAnchorEl] = useState(null);
  const cityMenuOpen = Boolean(cityAnchorEl);
  const handleCityClick = (event) => {
    setCityAnchorEl(event.currentTarget);
  };
  const handleCityClose = () => {
    setCityAnchorEl(null);
  };
  const handleCitySelect = (city) => {
    // Cities can belong to a different county/state/country than the one
    // currently selected, so re-resolve the whole chain (from the /city/list/all
    // lookup joins) rather than just swapping the city — otherwise brand/mail
    // queries would combine a stale country/state/county with the new city.
    setSelCountry(city?.countries?.[0]?.uuid);
    setSelState(city?.states?.[0]?.uuid);
    setSelCounty(city?.county_uuid);
    setSelCity(city?.uuid);
    setcityactive(true);
    // The previously selected store almost certainly doesn't exist in the
    // new city — clear it so the "Do you Know" panel and the auto-select
    // effect (which only run when selBrand is empty) can pick the new
    // city's first available store, matching what a category click does.
    setSelBrand([]);
    setActiveBrand([]);
    setCityAnchorEl(null);
  };

  const [mobileView, setMobileView] = useState(false);

  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 767
        ? setMobileView(true)
        : setMobileView(false);
    };
    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());

    return () => {
      window.removeEventListener("resize", () => setResponsiveness());
    };
  }, []);

  const [cookies, setCookie, removeCookie] = useCookies([
    "username",
    "token",
    "passcode",
  ]);
  const logoutHandler = async () => {
    setData({});
    setUserDetails({});
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("token");
    localStorage.removeItem("auth");
    localStorage.clear();
    const cookieOptions = {
      path: "/",
      secure: REACT_APP_COOKIE_SECURE,
      domain: REACT_APP_COOKIE_DOMAIN,
    };
    removeCookie("dInfoUserEmail", cookieOptions);
    removeCookie("dInfoUserId", cookieOptions);
    removeCookie("dInfoUserType", cookieOptions);
    removeCookie("dInfoToken", cookieOptions);
  };

  const handlelogout = () => {
    setPayloadsLogout({
      user_uuid: userdata?.uuid,
    });
    setTimeout(() => {
      navigate("/login");
      logoutHandler();
    }, 1000);
  };

  const hideHomeAction = location?.pathname !== "/home";
  // const NotificationIcon = () => {
  const [showNotification, setShowNotification] = useState(false);
  const handleNotificationClick = () => {
    // <IconMenuNotifications />
    setShowNotification(!showNotification);
  };

  const redirecttopopuppage = () => {
    navigate("/PopUp-Adds");
  };
  // Split so the home-variant header can lay the location pill out on its
  // own line below the logo (matching the native app) instead of bundling
  // it in with the icon row — every other caller just concatenates both
  // pieces back together via the `navItems` field below, unchanged.
  const locationPill = !hideHomeAction && (
    <>
      {window.location.pathname !== "/Notifications" &&
            window.location.pathname !== "/delete-account" &&
            (isCityLoading || !cityName ? (
              <Skeleton
                variant="rounded"
                width={mobileView ? 78 : 110}
                height={mobileView ? 30 : 32}
                sx={{
                  borderRadius: "24px",
                  bgcolor: isLight
                    ? "rgba(17,24,39,0.08)"
                    : "rgba(255,255,255,0.15)",
                }}
              />
            ) : (
              <Box
                onClick={handleCityClick}
                role="button"
                tabIndex={0}
                aria-label="Change city"
                aria-haspopup="true"
                title="Change city"
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    handleCityClick(e);
                  }
                }}
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: mobileView ? "2px" : "5px",
                  padding: mobileView ? "4px 6px 4px 5px" : "6px 12px 6px 8px",
                  borderRadius: "24px",
                  background: isLight ? "#fff" : "rgba(255,255,255,0.13)",
                  border: isLight
                    ? "1px solid #E5E7EB"
                    : "1px solid rgba(168,232,144,0.35)",
                  boxShadow: isLight
                    ? "none"
                    : "0 1px 4px rgba(0,0,0,0.18), inset 0 1px 0 rgba(255,255,255,0.12)",
                  whiteSpace: "nowrap",
                  backdropFilter: isLight ? "none" : "blur(6px)",
                  WebkitBackdropFilter: isLight ? "none" : "blur(6px)",
                  cursor: "pointer",
                  transition: "background 0.2s ease",
                  "&:hover": {
                    background: isLight
                      ? "rgba(17,24,39,0.04)"
                      : "rgba(255,255,255,0.22)",
                  },
                }}
              >
                <LocationOn
                  sx={{
                    fontSize: mobileView ? "0.9rem" : "1rem",
                    color: isLight ? "#1F8A4C" : "#a8e890",
                    flexShrink: 0,
                    mt: "1px",
                  }}
                />
                <span
                  style={{
                    fontSize: mobileView ? "0.74rem" : "0.83rem",
                    fontWeight: 600,
                    color: isLight ? "#111827" : "#fff",
                    letterSpacing: "0.2px",
                  }}
                >
                  {cityName}
                </span>
                <KeyboardArrowDown
                  sx={{
                    fontSize: mobileView ? "0.9rem" : "1.1rem",
                    color: isLight ? "#111827" : "rgba(255,255,255,0.8)",
                    flexShrink: 0,
                  }}
                />
              </Box>
            ))}

          <Menu
            anchorEl={cityAnchorEl}
            open={cityMenuOpen}
            onClose={handleCityClose}
            PaperProps={{
              elevation: 0,
              sx: {
                mt: 1,
                maxHeight: 320,
                minWidth: 180,
                background: "rgba(255, 255, 255, 0.72)",
                backdropFilter: "saturate(180%) blur(20px)",
                WebkitBackdropFilter: "saturate(180%) blur(20px)",
                border: "1px solid rgba(0, 0, 0, 0.08)",
                borderRadius: "12px",
                boxShadow:
                  "0 4px 12px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06)",
                color: "#333",
                "& .MuiButtonBase-root": {
                  fontSize: "0.85rem",
                  borderRadius: "8px",
                  mx: 0.5,
                  my: "1px",
                  transition: "background 0.2s ease",
                  "&:hover": {
                    background: "rgba(84, 172, 52, 0.08)",
                  },
                  "&.Mui-selected": {
                    background: "rgba(84, 172, 52, 0.14)",
                    fontWeight: 600,
                    "&:hover": {
                      background: "rgba(84, 172, 52, 0.18)",
                    },
                  },
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            {isCityLoading ? (
              <MenuItem disabled>Loading cities…</MenuItem>
            ) : sortedCityData?.length > 0 ? (
              sortedCityData.map((city, index) => (
                <React.Fragment key={city?.uuid}>
                  <MenuItem
                    selected={city?.uuid === selCity}
                    onClick={() => handleCitySelect(city)}
                  >
                    {getCityMenuLabel(city)}
                    {city?.uuid === homeCityUuid ? " (Home)" : ""}
                  </MenuItem>
                  {index === 0 &&
                    city?.uuid === homeCityUuid &&
                    sortedCityData.length > 1 && <Divider />}
                </React.Fragment>
              ))
            ) : (
              <MenuItem disabled>No cities available</MenuItem>
            )}
          </Menu>
    </>
  );

  const actionIcons = (
    <>
      {!hideHomeAction && (
        <>
          {window.location.pathname === "/Notifications" ||
          window.location.pathname === "/delete-account"
            ? ""
            : !mobileView && (
                <IconButton
                  aria-label="search"
                  onClick={() => handleNavLinksClick("search")}
                  style={{}}
                >
                  <SearchOutlined sx={{ fontSize: 30, color: "#fff" }} />
                </IconButton>
              )}

          {
            window.location.pathname === "/Notifications" ||
            window.location.pathname === "/delete-account" ? (
              ""
            ) : (
              <IconButton
                aria-label="notification"
                onClick={onDrawerNotification}
                sx={
                  mobileView
                    ? { backgroundColor: "rgba(255,255,255,0.18)" }
                    : {}
                }
              >
                <Badge badgeContent={unread?.unread} color="error">
                  <NotificationsIcon
                    color="action"
                    sx={{
                      marginTop: "0px",
                      fontSize: mobileView ? "1.45rem" : "1.8rem",
                      color: isLight ? "#111827" : "#fff",
                    }}
                  />
                </Badge>
              </IconButton>
            )

            // <div style={{margin: '0 5px', position: 'relative'}}>
            //   <super style={{ color: "red" }}>
            //     <img src={logo} alt="logo" style={{ width: "auto", height: mobileView ? "25px" : "30px" }} onClick={onDrawerNotification} />
            //     {unread?.unread === 0 ? "" :  <span style={styles.unreadCount}>{unread?.unread === 0 ? "" : unread?.unread}</span>}
            //   </super>
            //
            // </div>
          }
          {
            !mobileView &&
            (window.location.pathname === "/Notifications" ||
              window.location.pathname === "/delete-account")
              ? ""
              : !mobileView && (
                  <IconButton
                    aria-label="notification"
                    onClick={handleClickOpen1}
                  >
                    <Badge badgeContent={Popupaddsdata?.count} color="action">
                      <LoopIcon
                        sx={{
                          marginTop: "0px",
                          fontSize: "1.8rem",
                          color: "#fff",
                        }}
                      />
                    </Badge>
                  </IconButton>
                )

            // <div style={{margin: '0 5px'}}>
            //   <super style={{ color: "red" }}>
            //     <img src={Updatelogo} alt="logo" style={{ width: "auto", height: mobileView ? "25px" : "30px" }} onClick={handleClickOpen1} />{Popupaddsdata?.count === 0 ? "" : Popupaddsdata?.count}
            //   </super>
            // </div>
          }
        </>
      )}

      <Avatar
        onClick={handleClick}
        sx={{
          bgcolor: isLight ? "#E8EEE9" : deepOrange[500],
          color: isLight ? "#374151" : undefined,
          border: isLight ? "none" : undefined,
          ml: mobileView ? 0 : 3,
          fontSize: 15,
          height: mobileView ? "30px" : "35px",
          width: mobileView ? "30px" : "35px",
          marginLeft: 0,
          padding: mobileView ? "2px" : "4px",
          boxSizing: "border-box",
        }}
        alt="user picture"
        src={userDetails?.avatar}
      >
        {`${userDetails?.firstName?.substring(
          0,
          1,
        )}${userDetails?.lastName?.substring(0, 1)}`}
      </Avatar>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            mt: 1.5,
            background: "rgba(255, 255, 255, 0.72)",
            backdropFilter: "saturate(180%) blur(20px)",
            WebkitBackdropFilter: "saturate(180%) blur(20px)",
            border: "1px solid rgba(0, 0, 0, 0.08)",
            borderRadius: "12px",
            boxShadow:
              "0 4px 12px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06)",
            color: "#333",
            "& .MuiButtonBase-root": {
              fontSize: "0.8rem",
              borderRadius: "8px",
              mx: 0.5,
              transition: "background 0.2s ease",
              "&:hover": {
                background: "rgba(84, 172, 52, 0.08)",
              },
              "& svg": {
                color: "#54ac34",
              },
            },
            "& .MuiDivider-root": {
              backgroundColor: "rgba(0, 0, 0, 0.06)",
              mx: 1,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {mobileView && (
          <>
            {window.location.pathname === "/Notifications" ||
            window.location.pathname === "/delete-account" ? (
              ""
            ) : (
              <MenuItem onClick={() => handleNavLinksClick("search")}>
                <IconButton
                  aria-label="search"
                  onClick={() => handleNavLinksClick("search")}
                >
                  <SearchOutlined sx={{ fontSize: 30 }} />
                </IconButton>
                Search
              </MenuItem>
            )}

            {window.location.pathname === "/Notifications" ||
            window.location.pathname === "/delete-account" ? (
              ""
            ) : (
              <MenuItem onClick={handleClickOpen1}>
                <div>
                  <super style={{ color: "red" }}>
                    {" "}
                    <img
                      src={Updatelogo}
                      alt="logo"
                      style={{
                        width: mobileView ? "30px" : "46px",
                        height: mobileView ? "30px" : "43px",
                      }}
                      onClick={handleClickOpen1}
                    />
                    {Popupaddsdata?.count === 0
                      ? ""
                      : Popupaddsdata?.count}{" "}
                  </super>{" "}
                  Story{" "}
                </div>
              </MenuItem>
            )}
          </>
        )}
        <MenuItem onClick={() => navigate("/my-account")}>My Account</MenuItem>
        <MenuItem onClick={() => navigate("/rewards")}>My Rewards</MenuItem>
        <MenuItem onClick={() => navigate("/my-bookings")}>
          My Bookings
        </MenuItem>
        <MenuItem onClick={() => navigate("/Notifications")}>
          Notifications
        </MenuItem>
        <MenuItem
          onClick={() =>
            navigate("/favourites", {
              state: {
                selCountry: selCountry,
                selState: selState,
                selCity: selCity,
                selCounty: selCounty,
                selCategory: selCategory,
              },
            })
          }
        >
          My Favourites
        </MenuItem>
        <MenuItem onClick={() => navigate("/new-password")}>
          Change Password
        </MenuItem>
        <MenuItem onClick={() => navigate("/support")}>Support</MenuItem>
        <MenuItem onClick={() => navigate("/delete-account")}>
          Delete Account
        </MenuItem>

        {/* /delete-account */}
        <Divider />
        <MenuItem onClick={handlelogout}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </>
  );

  return {
    locationPill,
    actionIcons,
    // Back-compat shape for every caller that just wants one combined block
    // in a single row (desktop AppBar) — unchanged from before the split.
    navItems: (
      <>
        {locationPill}
        {actionIcons}
      </>
    ),
  };
};
